import { EddyPrefs } from 'api';

export const DEFAULT_EDDY_PREFS: Record<keyof EddyPrefs, boolean> = {
  isAutoChaptersEnabled: false,
  isAutoProjectNameEnabled: false,
  shouldRemoveFillerWords: false,
  isPodcastPersonalizationEnabled: false,
};
